import { render, staticRenderFns } from "./ChooseSystem.vue?vue&type=template&id=5fe49108&scoped=true&"
import script from "./ChooseSystem.vue?vue&type=script&lang=js&"
export * from "./ChooseSystem.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSystem.vue?vue&type=style&index=0&id=5fe49108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe49108",
  null
  
)

export default component.exports